import { push } from "react-router-redux";
import { startSubmit, stopSubmit, reset } from "redux-form";
import { setLoading } from "./common.actions";
import { setPagination } from "./admin.actions";

import api from "../services/api";
import { showError, setSubHeader } from "./common.actions";
import "../utils/arrays";

export const CREATE_EMPLOYER_START = "CREATE_EMPLOYER_START";
export const CREATE_EMPLOYER_SUCCESS = "CREATE_EMPLOYER_SUCCESS";
export const CREATE_EMPLOYER_ERROR = "CREATE_EMPLOYER_ERROR";

export const CREATE_CANDIDATE_START = "CREATE_CANDIDATE_START";
export const CREATE_CANDIDATE_SUCCESS = "CREATE_CANDIDATE_SUCCESS";
export const CREATE_CANDIDATE_ERROR = "CREATE_CANDIDATE_ERROR";

export const UPDATE_CANDIDATE_START = "UPDATE_CANDIDATE_START";
export const UPDATE_CANDIDATE_SUCCESS = "UPDATE_CANDIDATE_SUCCESS";
export const UPDATE_CANDIDATE_ERROR = "UPDATE_CANDIDATE_ERROR";

export const GET_USER_START = "GET_USER_START";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_STATS_SUCCESS = "GET_USER_STATS_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";

export const GET_EMAIL_TYPES_SUCCESS = "GET_EMAIL_TYPES_SUCCESS";
export const GET_EMAIL_TYPES_OPTIONS_SUCCESS =
  "GET_EMAIL_TYPES_OPTIONS_SUCCESS";

export const UPLOAD_RESUME_SUCCESS = "UPLOAD_RESUME_SUCCESS";

export const SET_MEMBER = "SET_MEMBER";
export const SHOW_TOAST = "SHOW_TOAST";
export const SET_USER_STATUS_LIST = "SET_USER_STATUS_LIST";

export const GET_ADMIN_ADMINS = "GET_ADMIN_ADMINS";
export const GET_ADMIN_MEMBERS_START = "GET_ADMIN_MEMBERS_START";
export const GET_ADMIN_MEMBERS_SUCCESS = "GET_ADMIN_MEMBERS_SUCCESS";
export const GET_ADMIN_MEMBERS_CSV_SUCCESS = "GET_ADMIN_MEMBERS_CSV_SUCCESS";
export const GET_ADMIN_MEMBERS_ERROR = "GET_ADMIN_MEMBERS_ERROR";

export const COMPANY_SIGNUP_FORM = "CompanySignUp";
export const MEMBER_SIGNUP_FORM = "memberSignUp";
export const MEMBER_UPDATE_FORM = "memberUpdate";
export const VERIFY_ACCOUNT_FORM = "VerifyAccount";
export const EDIT_EMPLOYER_PROFILE_FORM = "EditEmployerProfile";
export const EDIT_EMPLOYER_EMAIL_PREFERENCES = "EditEmployerEmailPreferences";

export function onCreateEmployerStart() {
  return {
    type: CREATE_EMPLOYER_START
  };
}

export function onCreateEmployerSuccess() {
  return {
    type: CREATE_EMPLOYER_SUCCESS
  };
}

export function onCreateEmployerError(error) {
  return {
    type: CREATE_EMPLOYER_ERROR,
    error
  };
}

export function onCreateCandidateStart() {
  return {
    type: CREATE_CANDIDATE_START
  };
}

export function onCreateCandidateSuccess(data) {
  return {
    type: CREATE_CANDIDATE_SUCCESS,
    data
  };
}

export function onCreateCandidateError(error) {
  return {
    type: CREATE_CANDIDATE_ERROR,
    error
  };
}

export function onUpdateCandidateStart() {
  return {
    type: UPDATE_CANDIDATE_START
  };
}

export function onUpdateCandidateSuccess(data) {
  return {
    type: UPDATE_CANDIDATE_SUCCESS,
    data
  };
}

export function onUpdateCandidateError(error) {
  return {
    type: UPDATE_CANDIDATE_ERROR,
    error
  };
}

export function onGetUserStart() {
  return {
    type: GET_USER_START
  };
}

export function onGetUserSuccess(data) {
  return {
    type: GET_USER_SUCCESS,
    data
  };
}

export function onGetUserStatsSuccess(data) {
  return {
    type: GET_USER_STATS_SUCCESS,
    data
  };
}

export function onGetUserError(error) {
  return {
    type: GET_USER_ERROR,
    error
  };
}

export function onUploadResumeSuccess() {
  return {
    type: UPLOAD_RESUME_SUCCESS
  };
}

export function setMember(member) {
  return {
    type: SET_MEMBER,
    member
  };
}

export function setUserStatusList(data) {
  return {
    type: SET_USER_STATUS_LIST,
    data
  };
}

export function onGetAdminMembersStart() {
  return {
    type: GET_ADMIN_MEMBERS_START
  };
}

export function onGetAdminMembersSuccess(data) {
  return {
    type: GET_ADMIN_MEMBERS_SUCCESS,
    data
  };
}

export function onGetAdminMembersCsvSuccess(data) {
  return {
    type: GET_ADMIN_MEMBERS_CSV_SUCCESS,
    data
  };
}

export function onGetAdminMembersError() {
  return {
    type: GET_ADMIN_MEMBERS_ERROR
  };
}

export function onGetEmailTypesSuccess(data) {
  return {
    type: GET_EMAIL_TYPES_SUCCESS,
    data
  };
}

export function onGetEmailTypesOptionsSuccess(data) {
  return {
    type: GET_EMAIL_TYPES_OPTIONS_SUCCESS,
    data
  };
}

export function createEmployer(data) {
  return dispatch => {
    dispatch(onCreateEmployerStart());
    dispatch(startSubmit(COMPANY_SIGNUP_FORM));
    api
      .createEmployer(data)
      .then(res => {
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("User:Id", res.data.data.id);
        localStorage.setItem("Company:Id", res.data.data.profile.company_id);
        localStorage.setItem("companyName", res.data.data.profile.company.name);
        localStorage.setItem("role", "employer");
        localStorage.setItem("verified", false);
        dispatch(onCreateEmployerSuccess());
        api
          .getCompanyById(res.data.data.profile.company_id)
          .then(savedCompany => {
            const data = savedCompany.data.data;
            const companyFields = [
              "company_size_id",
              "location",
              "url",
              "summary",
              "industry_id"
            ];
            const isCompanyCompleted = companyFields.every(cf => {
              return data[cf] !== null && data[cf] !== undefined;
            });

            if (isCompanyCompleted) {
              dispatch(push("/company/home"));
            } else {
              dispatch(push(`create-company/${data.name}`));
            }
          });
      })
      .catch(error => {
        dispatch(stopSubmit(COMPANY_SIGNUP_FORM, error.response.data.errors));
        dispatch(onCreateEmployerError(error.response.data));
      });
  };
}

export function createCandidate(user) {
  return dispatch => {
    dispatch(onCreateCandidateStart());
    api
      .createCandidate(user)
      .then(res => {
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("User:Id", res.data.data.id);
        localStorage.setItem("role", "member");
        dispatch(onCreateCandidateSuccess(res.data));
        dispatch(push("/member/complete-profile"));
      })
      .catch(error => {
        dispatch(stopSubmit(MEMBER_SIGNUP_FORM, error.response.data.errors));
        dispatch(onCreateCandidateError(error.response.data));
      });
  };
}

export function prepareUserUpdateRequest(form, redirect, formName) {
  return dispatch => {
    let data = { ...form };

    if (data.education) {
      data.education = data.education
        .filter(el => el && !el.remove)
        .map(el => ({
          ...el[0],
          school_id: el[0].customOption ? null : el[0].id || el[0].school_id,
          school_name: el[0].value || el[0].school_name
        }));
    } else {
      delete data.education;
    }

    if (data.work_history) {
      data.work_history = data.work_history
        .filter(el => el && !el.remove)
        .map(el => ({
          ...el[0],
          company_id: el[0].customOption ? null : el[0].id || el[0].company_id,
          company_name: el[0].name || el[0].company_name
        }));
    } else {
      delete data.work_history;
    }

    if (data.data) {
      delete data.data;
    }

    if (data.links) {
      data.links = data.links
        .filter(el => el && !el.remove)
        .map(el => {
          if (!el) return null;
          return {
            category: Object.keys(el)[0],
            url: el[Object.keys(el)[0]]
          };
        });
    } else {
      delete data.links;
    }

    if (data.skills) {
      data.skills = data.skills.map((el, i) => ({
        id: i
      }));
      if (data.skills[0]) delete data.skills[0];
      data.skills.sort();
      data.skills.clean();
    }

    if (data.city_obj) {
      delete data.city_obj;
    }

    if (data.resume) {
      data.resume_name = data.resume.name;
    }

    dispatch(updateUser(data, redirect, formName));
  };
}

export function prepareUserUpdateResponse(user) {
  return dispatch => {
    if (user) {
      user.education = user.education.map(el => [
        {
          degree: el.degree,
          value: el.school.value,
          school_id: el.school_id
        }
      ]);

      user.work_history = user.work_history.map(el => [
        {
          role: el.role,
          name: el.company.name,
          company_id: el.company_id,
          company_name: el.company.name,
          years: el.years
        }
      ]);

      user.links = user.links.map(el => ({
        [el.category]: el.url,
        category: el.category,
        url: el.url
      }));

      user.skills_all = user.skills.reduce(
        (h, a) =>
          Object.assign(h, {
            [a.description.category_id]: (
              h[a.description.category_id] || []
            ).concat(a)
          }),
        {}
      );

      if (user.skills) {
        user.skills_aux = [];
        user.skills.forEach(skill => {
          user.skills_aux[skill.skill_id] = true;
        });
        delete user.skills;
        user.skills = user.skills_aux;
        delete user.skills_aux;
      }

      user.work_references = user.work_references.map(el => {
        delete el.id;
        delete el.user_id;
        delete el.relationship;
        return el;
      });

      if (user.city_obj) {
        delete user.city_obj;
      }

      if (user.profile) {
        user.commute_city_id = user.profile.commute_city_id;
        user.level_id = user.profile.level_id;
        user.primary_industry_id = user.profile.primary_industry_id;
        user.primary_industry_other = user.profile.primary_industry_other;
        user.secondary_industry_id = user.profile.secondary_industry_id;
        user.secondary_industry_other = user.profile.secondary_industry_other;
        user.full_time_job = user.profile.full_time_job;
        user.professional_summary = user.profile.professional_summary;
        user.resume = user.profile.resume_name;

        if (user.profile.city) {
          user.city_obj = {
            description: user.profile.city,
            id: 1
          };
        }
      }

      dispatch(onGetUserSuccess(user));
    }
  };
}

export function updateUserData(user, redirect, formName) {
  return dispatch => {
    dispatch(prepareUserUpdateRequest(user, redirect, formName));
  };
}

export function updateUser(user, redirect, formName) {
  return dispatch => {
    dispatch(onUpdateCandidateStart());
    api
      .updateUser(user)
      .then(res => {
        let role = localStorage.getItem("role");

        if (user.first_name && role !== "admin") {
          localStorage.setItem("userName", user.first_name);
        }

        if (user.resume && typeof user.resume !== "string") {
          let formData = new FormData();
          formData.append("resume", user.resume);
          formData.append("id", user.id);

          api
            .uploadResume(formData)
            .then(res => {
              dispatch(onUploadResumeSuccess());
              dispatch(onUpdateCandidateSuccess(res.data));
              if (redirect) dispatch(push(redirect));
            })
            .catch(error => {
              dispatch(
                stopSubmit(formName || MEMBER_UPDATE_FORM, {
                  resume: "File size must must not exceed 2 MB"
                })
              );
              dispatch(onUpdateCandidateError(error));
            });
        } else {
          dispatch(onUpdateCandidateSuccess(res.data));
          if (redirect) dispatch(push(redirect));
        }
      })
      .catch(error => {
        dispatch(
          stopSubmit(formName || MEMBER_UPDATE_FORM, error.response.data.errors)
        );
        dispatch(showError(error.response.data.message));
      });
  };
}

export function getUserData(callback) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .getUserData()
      .then(res => {
        dispatch(prepareUserUpdateResponse(res.data.data));
        if (callback) {
          callback();
        }
        dispatch(setLoading(false));
      })
      .catch(error => {
        dispatch(onGetUserError(error.response));
        dispatch(setLoading(false));
      });
  };
}

export function getUserDataById(id, callback) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .getMemberById(id)
      .then(res => {
        dispatch(prepareUserUpdateResponse(res.data.data));
        if (callback) {
          callback();
        }
        dispatch(setLoading(false));
      })
      .catch(error => {
        dispatch(onGetUserError(error.response));
        dispatch(setLoading(false));
      });
  };
}

export function getUserStats(activeItem) {
  return dispatch => {
    api
      .getUserStats()
      .then(res => {
        dispatch(onGetUserStatsSuccess(res));

        const statsSubHeader = {
          items: [
            {
              caption: `Matches (${res.data.data.navbar.matches})`,
              url: "/member/projects/matches"
            },
            {
              caption: `Pitches (${res.data.data.navbar.pitches})`,
              url: "/member/projects/pitches"
            },
            {
              caption: `SOWs (${res.data.data.navbar.sow})`,
              url: "/member/projects/sows"
            },
            {
              caption: `Completed (${res.data.data.navbar.completed})`,
              url: "/member/projects/completed"
            },
            {
              caption: `Invoices (${res.data.data.navbar.invoices})`,
              url: "/member/projects/invoices"
            }
          ],
          activeItem: activeItem ? activeItem : 0
        };

        dispatch(setSubHeader(statsSubHeader));
      })
      .catch(error => {
        dispatch(onGetUserError(error.response));
      })
      .finally(() => {});
  };
}

/**
 * Verify if the user has the selected role assigned.
 * @param {Role []} memberRoles
 * @param {String} role
 */
export function userHasRole(memberRoles, role) {
  let match = _.filter(memberRoles, memberRole => {
    if (memberRole.name === role) {
      return true;
    }

    return false;
  });

  return match.length > 0;
}

export function verifyAccount(fields, projectCount = 0) {
  return dispatch => {
    dispatch(setLoading(true));

    // Verify Credit Card
    const verifyCreditCard = () => {
      let payload = {
        ccv: fields.ccv,
        expiration_date: fields.expiration_date,
        name: fields.name,
        number: fields.number
      };

      if (fields.project_id) {
        payload.project_id = fields.project_id;
      }

      // Clean preexistent errors.
      dispatch(showError(null));

      return api
        .verifyCreditCard(payload)
        .then(() => {
          localStorage.setItem("verified", true);

          dispatch(
            push(`/company/${projectCount > 0 ? "projects" : "payment"}`)
          );
        })
        .catch(error => {
          dispatch(stopSubmit(VERIFY_ACCOUNT_FORM, error.response.data.errors));
          dispatch(
            showError(
              "Sorry your credit card details are not valid. Please try again."
            )
          );
          return "Sorry your credit card details are not valid. Please try again.";
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    };

    // Verify Referral Code
    const verifyReferralCodeAndCreditCard = () => {
      let payload = { referral_code: fields.referral_code };

      if (fields.project_id) {
        payload.project_id = fields.project_id;
      }

      api
        .verifyReferralCode(payload)
        .then(() => {
          localStorage.setItem("verified", true);

          dispatch(push(`/company/${projectCount > 0 ? "projects" : "home"}`));
        })
        .catch(error => {
          dispatch(stopSubmit(VERIFY_ACCOUNT_FORM, error.response.data.errors));
          dispatch(
            showError(
              "Sorry the code you entered is invalid. Please try again or enter a credit card instead."
            )
          );
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    };

    //ask if referralCode is in the object
    if (fields.referral_code) {
      verifyReferralCodeAndCreditCard();
    } else {
      verifyCreditCard();
    }

    dispatch(startSubmit(VERIFY_ACCOUNT_FORM));
  };
}

export function getMember(memberId) {
  return dispatch => {
    api
      .getMemberById(memberId)
      .then(response => {
        const { data } = response.data;

        dispatch(setMember(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      });
  };
}

export function onShowToast(show) {
  return {
    type: SHOW_TOAST,
    showToast: show
  };
}

export function showToast(show) {
  return dispatch => {
    dispatch(onShowToast(show));
  };
}

export function downloadResume(userId, download = false) {
  return () => {
    api
      .downloadResume(userId)
      .then(res => {
        if (!download) {
          // Open in a new tab (view)
          window.open(res.data.data, "_blank");
        } else {
          // Download the file

          const fileUrl = res.data.data;
          const fileName = fileUrl.split("/").pop();

          // We will create a temp anchor element
          // This should allow us to download the files using HTML5 download attribute
          var temp_download = document.createElement("a");
          temp_download.href = fileUrl;
          temp_download.download = fileName.split("?")[0];

          // Append the a to the DOM and then trigger the click
          document.body.appendChild(temp_download);
          temp_download.click();

          // Remove the attribute from the DOM, we don't need it anymore.
          temp_download.remove();
        }
      })
      .catch(() => {});
  };
}

export function getUserStatusList() {
  return dispatch => {
    api
      .getUserStatusList()
      .then(response => {
        dispatch(setUserStatusList(response.data.data));
      })
      .catch(() => {});
  };
}

export function getAdminMembers(filters = "") {
  return dispatch => {
    dispatch(onGetAdminMembersStart());
    dispatch(setPagination({}));

    api
      .getAdminMembers(filters)
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(onGetAdminMembersSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetAdminMembersError());
      });
  };
}

export function getAdminMembersCSVData(filters = "") {
  return dispatch => {
    // dispatch(onGetAdminMembersStart());

    api
      .getAdminMembersForCSV(filters)
      .then(response => {
        const { data } = response.data;
        dispatch(onGetAdminMembersCsvSuccess(data));
      })
      .catch(() => {
        dispatch(onGetAdminMembersError());
      });
  };
}

export function updateCompanyOnEditEmployerProfile(profile) {
  return dispatch => {
    const companyName = localStorage.getItem("companyName");
    localStorage.setItem("companyName", profile.name);

    dispatch(setLoading(true));
    api
      .updateCompanyById(profile)
      .then(() => {
        dispatch(getUserData());
      })
      .catch(() => {
        localStorage.setItem("companyName", companyName);
      })
      .finally(() => {
        dispatch(reset(EDIT_EMPLOYER_PROFILE_FORM));
        dispatch(setLoading(false));
      });
  };
}

export function editEmployerProfile(payload) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .updateUser(payload.user)
      .then(res => {
        let user = res.data.data;
        let role = localStorage.getItem("role");

        if (user && role === "employer") {
          localStorage.setItem("userEmail", user.email);
          localStorage.setItem("userName", user.first_name);
        }

        dispatch(updateCompanyOnEditEmployerProfile(payload.company));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getEmailTypes() {
  return dispatch => {
    api
      .getEmailTypes()
      .then(res => {
        dispatch(onGetEmailTypesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getEmailTypesOptions() {
  return dispatch => {
    api
      .getEmailTypesOptions()
      .then(res => {
        dispatch(onGetEmailTypesOptionsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function updateEmailPreferences(payload) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .updateEmailPreferences(payload)
      .then(() => {
        dispatch(getUserData());
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js